import Api from "~/service/Api";

class AwsS3UploadPartSignedUrlRepository {
  fetchOne(query) {
    return Api.get("/aws-s3/upload-part/signed-urls", query);
  }
}

export default AwsS3UploadPartSignedUrlRepository;
